/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : store.ts
 *
 * Project Title : RDR7000
 *
 * Description   : Redux Store
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Amol Jagtap (H409453)
 *
 * @Date         : Aug 12, 2020
 *
 * @Version      : Version 1.0
 *
 * By            : Amol Jagtap (H409453)
 * On            : Aug 12, 2020
 * Description   : Add code to define Redux Store
 *
 *
 ******************************************************************************/

import { configureStore, ThunkAction, Action, getDefaultMiddleware } from '@reduxjs/toolkit';
import rootReducer from 'stores/GlobalStore/rootReducer';
import { api } from 'stores/middlewares';

export const store = configureStore({
  reducer: rootReducer,
  middleware: [...getDefaultMiddleware(), api],
  devTools: process.env.NODE_ENV === 'development',
});

export const initialRootState = store.getState();

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
